import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { TabItemInterface } from '@/modules/Chat/interfaces/TabItemInterface';
import TabItem from '@/modules/Chat/components/TabItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  props: {
    tabItems: {
        type: Array as PropType<TabItemInterface[]>,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: true,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
},
  setup(__props) {

const props = __props;



const noSearchResultsReturned = computed(() => {
    return !props.isLoading && props.tabItems.length <= 0;
});

return { __sfc: true,props, noSearchResultsReturned, TabItem }
}

})